
<!-- les autres sites -->
<div *ngIf="isMontDesAvaloirs === false && isMamSncf === false" class="row justify-content-around">
  <div class="col-11 col-sm-10">
    <mat-card class="col-12 primary-color">
      <h1 class="col-12"><b> {{ 'AUTOPARTAGE.AVANTAGE.TITLE' | translate }}</b></h1>
        <div class="row">
          <div class="col-md-3 col-6">
            <div class="row info-content justify-content-center ">
              <div class="col-9">
                <img src="../../../assets/img/Autopartage/Avantages/PictoAutopartage_Liberte.svg" alt="">
                <h4 class="bold">
                  {{ 'AUTOPARTAGE.AVANTAGE.TITLE1' | translate }}
                </h4>
                <h5>{{ 'AUTOPARTAGE.AVANTAGE.PARA1' | translate }}</h5>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-6">
            <div class="row info-content justify-content-center  ">
              <div class="col-9">
                <img src="../../../assets/img/Autopartage/Avantages/PictoAutopartage_Propre.svg" alt="">
                <h4 class="bold">
                  {{ 'AUTOPARTAGE.AVANTAGE.TITLE2' | translate }}
                </h4>
                <h5>
                  {{ 'AUTOPARTAGE.AVANTAGE.PARA2' | translate }}
                </h5>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-6">
            <div class="row info-content justify-content-around  ">
              <div class="col-9">
                <img src="../../../assets/img/Autopartage/Avantages/PictoAutopartage_Economie.svg" alt="">
                <h4 class="bold">
                  {{ 'AUTOPARTAGE.AVANTAGE.TITLE3' | translate }}
                </h4>
                <h5>
                  {{ 'AUTOPARTAGE.AVANTAGE.PARA3' | translate }}
                </h5>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-6">
            <div class="row info-content justify-content-around  ">
              <div class="col-9">
                <img src="../../../assets/img/Autopartage/Avantages/PictoAutopartage_Telephone.svg" alt="">
                <h4 class="bold">
                  {{ 'AUTOPARTAGE.AVANTAGE.TITLE4' | translate }}
                </h4>
                <h5>
                  {{ 'AUTOPARTAGE.AVANTAGE.PARA4' | translate }}
                </h5>
              </div>
            </div>
          </div>
        </div>     
    </mat-card>
  </div>
</div>


<!-- mam sncf -->
<div *ngIf="isMamSncf === true" class="row justify-content-around">
  <div class="col-11 col-sm-10">
    <mat-card class="col-12 primary-color">
      <h1 class="col-12"><b> {{ 'AUTOPARTAGE.AVANTAGE.TITLE' | translate }}</b></h1>
        <div class="row">
          <div class="col-md-3 col-12">
            <div class="row info-content justify-content-center ">
              <div class="col-9">
                <img src="../../../assets/img/MamSncf/PictoAutopartage_Liberte-01.svg" alt="">
                <h4 class="bold">
                  {{ 'AUTOPARTAGE.AVANTAGE.TITLE1' | translate }}
                </h4>
                <h5>{{ 'AUTOPARTAGE.AVANTAGE.PARA1' | translate }}</h5>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-12">
            <div class="row info-content justify-content-center  ">
              <div class="col-9">
                <img src="../../../assets/img/MamSncf/PictoAutopartage_Propre-01.svg" alt="">
                <h4 class="bold">
                  {{ 'AUTOPARTAGE.AVANTAGE.TITLE2' | translate }}
                </h4>
                <h5>
                  {{ 'AUTOPARTAGE.AVANTAGE.PARA2' | translate }}
                </h5>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-12">
            <div class="row info-content justify-content-around  ">
              <div class="col-9">
                <img src="../../../assets/img/MamSncf/PictoAutopartage_Economie-01.svg" alt="">
                <h4 class="bold">
                  {{ 'AUTOPARTAGE.AVANTAGE.TITLE3' | translate }}
                </h4>
                <h5>
                  {{ 'AUTOPARTAGE.AVANTAGE.PARA3' | translate }}
                </h5>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-12">
            <div class="row info-content justify-content-around  ">
              <div class="col-9">
                <img src="../../../assets/img/MamSncf/PictoAutopartage_Telephone-01.svg" alt="">
                <h4 class="bold">
                  {{ 'AUTOPARTAGE.AVANTAGE.TITLE4' | translate }}
                </h4>
                <h5>
                  {{ 'AUTOPARTAGE.AVANTAGE.PARA4' | translate }}
                </h5>
              </div>
            </div>
          </div>
        </div>     
    </mat-card>
  </div>
</div>


<!-- mont-des-avaloir -->
<div *ngIf="isMontDesAvaloirs === true" class="row justify-content-around">
  <div class="col-11 col-sm-10">
    <mat-card class="col-12 primary-color">
      <h1 class="col-12"><b> Vos avantages</b></h1>
       
      <div class="row">
          <div class="col-md-4 col-6">
            <div class="row info-content justify-content-center ">
              <div class="col-9">
                <img width="129" src="assets/img/communauté/CCMA/avantages/PictoAutopartage_Economie.svg" alt="">
                <h4 class="bold">
                  Des déplacements à moindre coût
                </h4>
                <h5>Un prix de location attractif : 5 € la demi-journée et 8 € la journée. Demandeurs d’emploi : bénéficiez d’un ½ tarif en vous rapprochant de la CCMA.</h5>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-6">
            <div class="row info-content justify-content-center  ">
              <div class="col-9">
                <img style="margin-bottom: 3em;" class="mt-5" width="90" src="assets/img/communauté/CCMA/avantages/Picto_voiture.svg" alt="">
                <h4 class="bold">
                  Les avantages d’une voiture, les contraintes en moins
                </h4>
                <h5>
                  J’ai une voiture à disposition, sans les frais d’entretien, d’assurance, de carburant qui me coûte en moyenne 6000 € par an.
                </h5>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-6">
            <div class="row info-content justify-content-around  ">
              <div class="col-9">
                <img width="129" src="assets/img/communauté/CCMA/avantages/PictoAutopartage_Liberte.svg" alt="">
                <h4 class="bold">
                  La liberté de déplacement
                </h4>
                <h5>
                  Je me déplace 7 jours sur 7, de 6h à 22h
                </h5>
              </div>
            </div>
          </div>
 
        </div>   


        <div class="row">
          <div class="col-md-4 col-6">
            <div class="row info-content justify-content-center ">
              <div class="col-9">
                <img style="margin-bottom: 2em;" class="mt-5" width="90" src="assets/img/communauté/CCMA/avantages/Picto_eco.svg" alt="">
                <h4 class="bold">
                  Une conduite écologique
                </h4>
                <h5>Je n’émets pas de CO2 et je roule aux énergies renouvelables (80 m2 de panneaux photovoltaïques produisent l’énergie pour rouler 90 000 km par an).</h5>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-6">
            <div class="row info-content justify-content-center  ">
              <div class="col-9">
                <img class="my-5" width="60" src="assets/img/communauté/CCMA/avantages/Picto_tout_compris.svg" alt="">
                <h4 class="bold">
                  Réservation tout compris
                </h4>
                <h5>
                  Je ne paie que la réservation et je suis assuré. L’électricité consommée et les kilomètres effectués sont compris dans la location.
                </h5>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-6">
            <div class="row info-content justify-content-around  ">
              <div class="col-9">
                <img width="129" src="assets/img/communauté/CCMA/avantages/PictoAutopartage_Telephone.svg" alt="">
                <h4 class="bold">
                  Une assistance 24/7
                </h4>
                <h5>
                  Un souci ? J’ai un interlocuteur disponible 24 heures sur 24, 7 jours sur 7. Je le contacte au numéro reçu lors de ma réservation.
                </h5>
              </div>
            </div>
          </div>
 
        </div>   

        <h2 class="col-12"><b>Demandeurs d'emploi, bénéficiez d'un demi-tarif. <br>
        Reseignements auprès des Maisons de Services Au Public -MSAP</b></h2>

    </mat-card>
  </div>
</div>



